import * as S from "./styled"
import { formatMoney } from "../../utils/tb/formatMoney"
import { TInstallmentOption } from "../../utils/@types/data/installment"

type Props = {
  options: TInstallmentOption[]
  selected: number | null
  loading: boolean
  error: string | null
  hasCardData: boolean
  onSelect: (installments: number) => void
}

const toMoney = (v: number) => formatMoney(Math.round(v * 100))

const InstallmentSelect = ({
  options,
  selected,
  loading,
  error,
  hasCardData,
  onSelect,
}: Props) => {
  return (
    <S.Wrapper>
      <S.Title>Parcelamento</S.Title>

      {!hasCardData && (
        <S.Message>Informe o número do cartão para ver as parcelas.</S.Message>
      )}
      {hasCardData && loading && <S.Message>Consultando parcelas...</S.Message>}
      {hasCardData && !loading && error && (
        <S.Message $error role="alert">
          {error}
        </S.Message>
      )}

      {!loading && options.length > 0 && (
        <S.List role="radiogroup" aria-label="Parcelamento">
          {options.map((o) => (
            <S.Option
              key={o.installments}
              type="button"
              role="radio"
              aria-checked={selected === o.installments}
              $active={selected === o.installments}
              onClick={() => onSelect(o.installments)}
            >
              <span>
                {o.installments}x de {toMoney(o.installmentAmount)}
              </span>
              <small>
                {o.installmentRate > 0 ? `Total: ${toMoney(o.totalAmount)}` : "sem juros"}
              </small>
            </S.Option>
          ))}
        </S.List>
      )}
    </S.Wrapper>
  )
}

export default InstallmentSelect
